import { UseFormReturn } from 'react-hook-form';
import { useCallback } from 'react';
import { BoloPanelFormType, BoloPanelView } from '@mark43/cad-api';
import { BoloPanelMetadataStore } from '../state/bolo-panel-metadata-store';
import { WorkspacePanel } from '../../../panels/workspace-panel';
import { runInAction } from 'mobx';

interface UseRefreshBoloDataProps {
    boloForm: UseFormReturn<BoloPanelFormType>;
    boloMetadataStore?: BoloPanelMetadataStore;
    workspacePanel?: WorkspacePanel<'BOLO'>;
}

export const useRefreshBoloPanel = (deps: UseRefreshBoloDataProps) => {
    const { boloForm, boloMetadataStore, workspacePanel } = deps;
    return useCallback(
        (boloPanelView: BoloPanelView) => {
            boloForm.reset(boloPanelView.boloPanelForm as BoloPanelFormType);
            boloMetadataStore?.setBoloPanelMetadata(boloPanelView.boloPanelMetadata);

            // Update workspace panel's linkedEntityId when BOLO is saved with an ID
            // This ensures panel reuse logic works correctly when opening the same BOLO
            const boloPanelFormId = boloPanelView.boloPanelForm.id;
            if (workspacePanel && boloPanelFormId) {
                runInAction(() => {
                    workspacePanel.setLinkedEntityId(boloPanelFormId);
                });
            }
        },
        [boloForm, boloMetadataStore, workspacePanel]
    );
};
